import {createFileRoute} from '@tanstack/react-router';
import {DepositApplicationExistsPage} from 'features/deposit/onboarding/pages/DepositApplicationExistsPage';

export const Route = createFileRoute(
  '/_protected/deposit-onboarding/$applicationId/exists',
)({
  component: DepositApplicationExistsPage,
  validateSearch: (search) => {
    return {
      productCode: search.productCode as string | undefined,
    };
  },
});
